import React from 'react';
import { useSelector } from 'react-redux';

import Logger from '../../../common/Logger';
import { BetaBadgeClasses } from '../../../common/components/Badge';
import RightSideMenu from '../../../shared-components/RightSideMenu/RightSideMenu';
import { selectRightSideNavMenu } from '../../../ui/UiSelectors';
import { LoggerFn } from '../../Shared/types';
import AIVoiceoverButton from '../components/AIVoiceoverButton';

const RightSideMenuContainer = () => {
  const rightSideNav = useSelector(selectRightSideNavMenu);

  const logger: LoggerFn = (id) => {
    Logger.accessTelemetry().increment(id);
  };
  const imagesUrl = __ASSETS_COMMON_IMAGES_URL__;

  return (
    <div className="flex items-center">
      <AIVoiceoverButton />
      <RightSideMenu
        {...{ ...rightSideNav, logger, BetaBadgeClasses, imagesUrl }}
      />
    </div>
  );
};
export default RightSideMenuContainer;
